import * as React from 'react'

import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { config } from '../../../../common/config'
import {
  IHomePageBlockComponent,
  ISearchCta
} from '../../../../typings/pageBlocks'
import ui from '../../../../common/constants/ui'
import NextGenImageWrapper from '../../nextGenImageWrapper'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../../components/imagePlaceholder'
import Button from '../../button'
import SearchLink from '../../../containers/searchLinkContainer'
import { getWindow } from '../../../../common/utils/window'

import * as styles from './aspirationalQualityItemsBlock.module.css'

interface IProps extends IHomePageBlockComponent {
  title: string
  cta: ISearchCta
}

const reportClick = (eventLabel: string, eventValue?: number) => {
  reportBlockClick('Aspirational Quality Items', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const placeholderRatio = 534 / 705

const aspirationalQualityItemsBlock = ({ currentSite, title, cta }: IProps) => {
  const imagePath = `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/aspirational-quality-items`

  return (
    <section
      className={styles.root}
      data-test-selector={'aspirationalQualityItemsBlock'}
    >
      <header className={styles.mobileHeader}>
        <h2 className={styles.title}>{title}</h2>
      </header>
      <div className={styles.coverImageWrapper}>
        <EnhancedLazyLoad
          offset={ui.lazyLoadOffset}
          placeholder={
            <ImagePlaceholder
              ratio={placeholderRatio}
              className={styles.coverImage}
            />
          }
        >
          <NextGenImageWrapper>
            <img
              className={styles.coverImage}
              src={`${imagePath}.webp`}
              alt={'Quality items'}
            />
          </NextGenImageWrapper>
        </EnhancedLazyLoad>
      </div>
      <div className={styles.textContent}>
        <header className={styles.desktopHeader}>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <Button
          type={Button.Type.Primary}
          large
          renderAs={SearchLink}
          locationParams={cta.urlSearchParams}
          className={styles.button}
          onClick={() => {
            reportClick(cta.title)
            getWindow().scrollTo(0, 0)
          }}
        >
          {cta.title}
        </Button>
      </div>
    </section>
  )
}

export default aspirationalQualityItemsBlock
